import { lastValueFrom } from 'rxjs';

import { API_URL, getApiUrl } from '@/utils/api';
import ApiBase from './ApiBase';

export default class ShippingService extends ApiBase {
  static baseUrl = getApiUrl(API_URL.ADMIN, '/shipping');

  getAvailableSlots(shippingId: string) {
    return lastValueFrom(this.api.getJSON(`${ShippingService.baseUrl}/drive/${shippingId}`));
  }

  getAvailableSlotsTopChrono(shippingId: string) {
    return this.api.getJSON(`${ShippingService.baseUrl}/topChrono/${shippingId}`);
  }

  checkSelectedTimeslot(shippingMode) {
    return this.api.postJSON(`${ShippingService.baseUrl}/checkTimeSlot/${shippingMode._id}`, shippingMode.bookingSlot);
  }
}
